import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { APIService } from './../api.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from "../services/data.service";
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import * as xlsx from 'xlsx';

export interface PeriodicElement {
  dt        : string;
  invoiceNo : number;
  customer  : string;
  gstIn     : string;
  igst      : string;
  sgst      : string;
  cgst      : string;
  taxAmt    : number;
  type      : string;
  totalAmt  : number;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { dt: '03-May-2021', invoiceNo: 101, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z4',igst:'',sgst:'250',cgst:'250',taxAmt:7500,type:'B2CS',totalAmt:8500 },
  { dt: '04-May-2021', invoiceNo: 201, customer: 'HAPPY HOMES', gstIn: '24AADFH5185N1Z6',igst:'',sgst:'130',cgst:'130',taxAmt:5330,type:'B2CS',totalAmt:6000 },
  { dt: '05-May-2021', invoiceNo: 301, customer: 'A R Hydraulic	', gstIn: '24AADFH6185N1Z8',igst:'',sgst:'400',cgst:'400',taxAmt:9800,type:'B2CS',totalAmt:10000 },
  { dt: '06-May-2021', invoiceNo: 401, customer: 'Sky Tech', gstIn: '24AADFH8185N1Z7',igst:'',sgst:'251',cgst:'251',taxAmt:4522,type:'B2CS',totalAmt:6000 },
  { dt: '07-May-2021', invoiceNo: 501, customer: 'Corporation', gstIn: '24AADFH9185N1Z3',igst:'',sgst:'',cgst:'',taxAmt:3000,type:'B2CS',totalAmt:4000 },
  { dt: '08-May-2021', invoiceNo: 601, customer: 'Peach', gstIn: '24AADFH1185N1Z4',igst:'',sgst:'',cgst:'',taxAmt:1800,type:'B2CS',totalAmt:3500 },
  { dt: '09-May-2021', invoiceNo: 701, customer: 'A R Hydraulic', gstIn: '24AADFH3185N1Z0',igst:'',sgst:'',cgst:'',taxAmt:7894,type:'B2CS',totalAmt:8500 },
  { dt: '10-May-2021', invoiceNo: 801, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:8000,type:'B2CS',totalAmt:9000 },
  { dt: '11-May-2021', invoiceNo: 901, customer: 'Sky Tech', gstIn: '24AADFH6185N1Z9',igst:'',sgst:'',cgst:'',taxAmt:4510,type:'B2CS',totalAmt:7000 },
];

const SALES_DATA: PeriodicElement[] = [
  { dt: '03-May-2021', invoiceNo: 101, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z4',igst:'',sgst:'',cgst:'',taxAmt:7500,type:'B2CS',totalAmt:8500 },
  { dt: '04-May-2021', invoiceNo: 201, customer: 'HAPPY HOMES', gstIn: '24AADFH5185N1Z6',igst:'',sgst:'',cgst:'',taxAmt:5330,type:'B2CS',totalAmt:6000 },
  { dt: '05-May-2021', invoiceNo: 301, customer: 'A R Hydraulic	', gstIn: '24AADFH6185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:9800,type:'B2CS',totalAmt:10000 },
  ];

  const CREDIT_DATA: PeriodicElement[] = [
    { dt: '06-May-2021', invoiceNo: 401, customer: 'Sky Tech', gstIn: '24AADFH8185N1Z7',igst:'',sgst:'',cgst:'',taxAmt:4522,type:'B2CS',totalAmt:6000 },
    { dt: '07-May-2021', invoiceNo: 501, customer: 'Corporation', gstIn: '24AADFH9185N1Z3',igst:'',sgst:'',cgst:'',taxAmt:3000,type:'B2CS',totalAmt:4000 },
    { dt: '08-May-2021', invoiceNo: 601, customer: 'Peach', gstIn: '24AADFH1185N1Z4',igst:'',sgst:'',cgst:'',taxAmt:1800,type:'B2CS',totalAmt:3500 },
    { dt: '09-May-2021', invoiceNo: 701, customer: 'A R Hydraulic', gstIn: '24AADFH3185N1Z0',igst:'',sgst:'',cgst:'',taxAmt:7894,type:'B2CS',totalAmt:8500 },
    { dt: '10-May-2021', invoiceNo: 801, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:8000,type:'B2CS',totalAmt:9000 },
    { dt: '11-May-2021', invoiceNo: 901, customer: 'Sky Tech', gstIn: '24AADFH6185N1Z9',igst:'',sgst:'',cgst:'',taxAmt:4510,type:'B2CS',totalAmt:7000 },
  ];
  
const DEBIT_DATA: PeriodicElement[] = [
  { dt: '09-May-2021', invoiceNo: 701, customer: 'A R Hydraulic', gstIn: '24AADFH3185N1Z0',igst:'',sgst:'',cgst:'',taxAmt:7894,type:'B2CS',totalAmt:8500 },
  { dt: '10-May-2021', invoiceNo: 801, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:8000,type:'B2CS',totalAmt:9000 },
  { dt: '11-May-2021', invoiceNo: 901, customer: 'Sky Tech', gstIn: '24AADFH6185N1Z9',igst:'',sgst:'',cgst:'',taxAmt:4510,type:'B2CS',totalAmt:7000 },
];


const B2B_DATA: PeriodicElement[] = [
  { dt: '03-May-2021', invoiceNo: 101, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z4',igst:'',sgst:'',cgst:'',taxAmt:7500,type:'B2CS',totalAmt:8500 },
  { dt: '04-May-2021', invoiceNo: 201, customer: 'HAPPY HOMES', gstIn: '24AADFH5185N1Z6',igst:'',sgst:'',cgst:'',taxAmt:5330,type:'B2CS',totalAmt:6000 },
  { dt: '05-May-2021', invoiceNo: 301, customer: 'A R Hydraulic	', gstIn: '24AADFH6185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:9800,type:'B2CS',totalAmt:10000 },
  ];

  const B2CS_DATA: PeriodicElement[] = [
    { dt: '06-May-2021', invoiceNo: 401, customer: 'Sky Tech', gstIn: '24AADFH8185N1Z7',igst:'',sgst:'',cgst:'',taxAmt:4522,type:'B2CS',totalAmt:6000 },
    { dt: '07-May-2021', invoiceNo: 501, customer: 'Corporation', gstIn: '24AADFH9185N1Z3',igst:'',sgst:'',cgst:'',taxAmt:3000,type:'B2CS',totalAmt:4000 },
    { dt: '08-May-2021', invoiceNo: 601, customer: 'Peach', gstIn: '24AADFH1185N1Z4',igst:'',sgst:'',cgst:'',taxAmt:1800,type:'B2CS',totalAmt:3500 },
    { dt: '09-May-2021', invoiceNo: 701, customer: 'A R Hydraulic', gstIn: '24AADFH3185N1Z0',igst:'',sgst:'',cgst:'',taxAmt:7894,type:'B2CS',totalAmt:8500 },
    { dt: '10-May-2021', invoiceNo: 801, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:8000,type:'B2CS',totalAmt:9000 },
    { dt: '11-May-2021', invoiceNo: 901, customer: 'Sky Tech', gstIn: '24AADFH6185N1Z9',igst:'',sgst:'',cgst:'',taxAmt:4510,type:'B2CS',totalAmt:7000 },
  ];
  
const B2CL_DATA: PeriodicElement[] = [
  { dt: '09-May-2021', invoiceNo: 701, customer: 'A R Hydraulic', gstIn: '24AADFH3185N1Z0',igst:'',sgst:'',cgst:'',taxAmt:7894,type:'B2CS',totalAmt:8500 },
  { dt: '10-May-2021', invoiceNo: 801, customer: 'Sky Tech', gstIn: '24AADFH4185N1Z8',igst:'',sgst:'',cgst:'',taxAmt:8000,type:'B2CS',totalAmt:9000 },
  { dt: '11-May-2021', invoiceNo: 901, customer: 'Sky Tech', gstIn: '24AADFH6185N1Z9',igst:'',sgst:'',cgst:'',taxAmt:4510,type:'B2CS',totalAmt:7000 },
];

@Component({
  selector: 'app-sales-summary',
  templateUrl: './sales-summary.component.html',
  styleUrls: ['./sales-summary.component.scss']
})

export class SalesSummaryComponent implements AfterViewInit 
{
  //MAT TABLE
  displayedColumns: string[] = ['dt', 'invoiceNo', 'customer', 'gstIn','taxAmt','igst','sgst','cgst','totalAmt','type'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  //pagination
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  //sorting
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  constructor(private modalService: NgbModal, private apiService: APIService, private appService: DataService,
    private router: Router,private commonSer: CommonService) {
  }
  
  statusID: number = 0;
  viewBtnstatus: number = 1;
  hideBtnstatus: number = 1;
  modalReference: any;
  curDate: any = new Date();
  period: any = 1;
  months: any = [];
  month: any;
  year: any;
  listData: any   = [];
  search: string = '';
  copyItems: any  = [];
  Items: any      = [];
  filter: any     = 0;
  type = {
    id: 0,
    name: ""
  };
  viewHeading: string = 'Sales Summary (GSTR-1)';

  ngOnInit(): void {
    //year and months periods
    this.year = this.curDate.getFullYear();
    this.month = this.curDate.getMonth() + 1;
    this.getPeriodData();
    this.listData = ELEMENT_DATA;
    // Get Data from Url
    this.type.id = Number(decodeURIComponent(this.commonSer.GetParam('TypeID') + ''));
    if(this.type.id != 0){
      this.hideBtnstatus = 0; //hide 
      this.typeFilter(this.type.id);
     }
  }
  ngAfterViewInit() {}
  view = {
      month: this.curDate.getMonth() + 1,
      year: this.curDate.getFullYear()
    }
  
  //get Months and year perionds
  getPeriodData() {
    this.months = this.commonSer.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    return;
  }
  backToHomeBtn() {
    window.location.href = "https://biziverse.com/main.html#/home";
  }
  //pandding and history filter..
  jobFilter(id: number) {
    this.statusID = id;
  }
  
  //filter
  typeFilter = (obj: any) => {
    this.viewBtnstatus = 1;
    this.statusID = obj;
    var tempItem: any = [];
    if (obj == 0) {
      tempItem = SALES_DATA;
    }
    else if (obj == 1) {
      tempItem = CREDIT_DATA;
      this.viewBtnstatus = 0;
    }
    else if (obj == 2) {
      tempItem = DEBIT_DATA;
      this.viewBtnstatus = 0;
    }
    else if (obj == 3) {
      tempItem = ELEMENT_DATA;
    }
    else if (obj == 4) {
      tempItem = B2B_DATA;
    }
    else if (obj == 5) {
      tempItem = B2CS_DATA;
    }
    else if (obj == 6) {
      tempItem = B2CL_DATA;
    }
    else if (obj == 7) {
      tempItem = B2B_DATA;
      this.viewBtnstatus = 0;
      this.viewHeading = "B2B Sales Summary";
    }
    else if (obj == 8) {
      tempItem = B2CS_DATA;
      this.viewBtnstatus = 0;
      this.viewHeading = "B2CS Sales Summary";
    }
    else if (obj == 9) {
      tempItem = B2CL_DATA;
      this.viewBtnstatus = 0;
      this.viewHeading = "B2CL Sales Summary";
    }
    this.dataSource.data = tempItem
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.matSort;
  }

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  //common search Mobile view
  applyFilterMob(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  exportToExcel() {
    const ws: xlsx.WorkSheet =
    xlsx.utils.json_to_sheet(this.dataSource.data);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb,this.viewHeading+'-Records.xlsx');
  }

  backBtn() {
    window.history.back();
  }
}
